<template>
  <div class="works">
    <div class="group-title">我最近</div>
    <div class="list">
      <div class="item">
        <div class="t-info">
          <img :src="imusicimg" alt />
          <div>
            <div>imusic音乐播放器（Windows）</div>
            <div>链接：https://pan.baidu.com/s/1mh0laUATMz5jC-HJ5nOdGA </div>
            <div>提取码：3mrd</div>
          </div>
        </div>
        <div class="s-info">
          <div class="info">该软件是本人接触electron后练手的第一个项目，功能包括：指定目录的本地音乐扫描、音乐播放进度拖动、播放列表、歌词同步滚动、音乐收藏、歌单管理等功能。目前仅适配了win10系统，win7也可正常使用，但体验上稍有差别。</div>
        </div>
      </div>
      <div class="item">
        <div class="t-info">
          <img :src="blogimg" alt />
          <div>
            <div>博客2.0</div>
            <a target="_blank" href="/#/blog">点击预览</a>
          </div>
        </div>
        <div class="s-info">
          <div class="info">这是我最近写的博客，原理是服务端读取md文件进行预览，部分功能还在开发中。</div>
        </div>
      </div>
      <div class="item">
        <div class="t-info">
          <img :src="noteimg" alt />
          <div>
            <div>notebook</div>
            <!-- <a target="_blank" href="http://ulog.top:8080">==>笔记</a> -->
            <router-link class="to-url" to="/secret">点击预览</router-link>
          </div>
        </div>
        <div class="s-info">
          <div class="info">暂无介绍。</div>
        </div>
      </div>
    </div>
    <div class="group-title">过去项目</div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="t-info">
          <img :src="item.img" alt />
          <div>
            <div>{{item.title}}</div>
            <div class="birth">{{item.birth}}</div>
            <a target="_blank" :href="item.target">点击预览</a>
          </div>
        </div>
        <div class="s-info">{{item.info}}</div>
      </div>
    </div>
    <div class="group-title">小demo</div>
    <div class="list">
      <div class="item">
        <div class="t-info">
          <img :src="imgChess" alt />
          <div>
            <div>五子棋</div>
            <div class="birth">2020年7月</div>
            <a target="_blank" href="/demo/chess/">点击预览</a>
          </div>
        </div>
        <div class="s-info">
          <div
            class="info"
          >这是一个五子棋小游戏。实现思路分为四部分：一是canvas绘出棋盘和棋子；二是初始化棋盘记录了每个点的具体参数；三是定义获胜规则；四是交互，包括监听鼠标和反馈。尚未加入AI算法。</div>
        </div>
      </div>
      <div class="item">
        <div class="t-info">
          <img :src="imgStar" alt />
          <div>
            <div>canvas动效</div>
            <div class="birth">2016年9月</div>
            <a target="_blank" href="/demo/star/">点击预览</a>
          </div>
        </div>
        <div class="s-info">
          <div
            class="info"
          >这个是三年前写的动效，那年那天在网友的博客发现这个有趣的动效，因此对canvas产生兴趣，以这个标准练手，通过自己的思路和知识实现了这个效果。实现思路是：渲染每个点，每个点包含不同的位置、样式、运动信息；监听鼠标事件，以鼠标坐标中心定义一各响应范围；在该范围内的点互相连接，需要用到“两点之间的距离公式”。</div>
        </div>
      </div>
      <div class="item">
        <div class="t-info">
          <img :src="imgCrop" alt />
          <div>
            <div>图片裁切</div>
            <div class="birth">2016年10月</div>
            <a target="_blank" href="/demo/crop/">点击预览</a>
          </div>
        </div>
        <div class="s-info">
          <div class="info">这是一个裁切图片jquery插件，以form形式或base64上传。也是很久之前写的，现在没什么特别的。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from "@/assets/rep/yss.png";
import img2 from "@/assets/rep/dsj.png";
import img3 from "@/assets/rep/bk.png";
import img4 from "@/assets/rep/bj.png";

import img5 from "@/assets/rep/chess.png";
import img6 from "@/assets/rep/star.png";
import img7 from "@/assets/rep/crop.png";

import img_imusic from "@/assets/rep/imusic.png"

export default {
  name: "works",
  data() {
    return {
      blogimg: img3,
      noteimg: img4,
      imgChess: img5,
      imgStar: img6,
      imgCrop: img7,
      imusicimg: img_imusic,
      list: [
        {
          img: img1,
          title: "云双闪",
          birth: "2019年10月初-2019年10月底",
          target: "/demo/yss/",
          info:
            "这个是一个过去项目开发“车载信息录入”的手机端页面（此预览无后端数据）。",
        },
        {
          img: img2,
          title: "大数据",
          birth: "2019年7月初-2019年10月初（一期）",
          target: "/demo/dsj/",
          info: "这个过去开发的一个交通大数据系统（此预览无后端数据）。",
        },
      ],
    };
  },
};
</script>

<style lang="less">
.works {
  background-color: #f0f0f0;
  .group-title {
    height: 5rem;
    line-height: 5rem;
    font-size: 1.6rem;
    margin-left: 2rem;
  }
  .list {
    width: 90%;
    margin: 0 auto;
    // display: flex;
    // flex-wrap: wrap;
    .item {
      margin: 0.66rem;
      background-color: #fff;
      .t-info {
        display: flex;
        justify-content: flex-start;
        img {
          width: 5rem;
          height: 5rem;
          border: 0.1rem solid skyblue;
          margin-top: 1rem;
          margin-left: 1rem;
        }
        & > div {
          margin-top: 1rem;
          margin-left: 1rem;
          a,
          .to-url {
            display: block;
            height: 2rem;
            line-height: 2rem;
          }
          .birth {
            color: #807e7e;
            font-size: .9rem;
          }
        }
      }
      .s-info {
        padding: 0.8rem;
        .info {
          font-size: .9rem;
        }
      }
    }
  }
}
</style>